import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class MockAuthGuard  {
  canActivate(): boolean {
    return true; // Always allow navigation
  }
}